var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\t\n\t\n\n\n\n\tHello\n\t"+_vm._s(_vm.serverStatus)+"\n\t"),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('view', 'sign-in')}}},[_vm._v("Go Back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }